import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import staticText from 'static/text_display.json';
import DownloadButton from '../IconButton/DownloadButton';
import UploadButton from '../IconButton/UploadButton';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import { ReactComponent as EditLogo } from 'images/icon_edit.svg';
import { ReactComponent as CloseLogo } from 'images/icon_close.svg';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles(theme => ({
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  mySvgStyle: {
    fill: theme.palette.text.primary,
    height: '25px',
    width: '25px',
    cursor: 'pointer',
  },
}));

const PanelHeaderBar = ({
  title,
  editable,
  closable,
  downloadable,
  uploadable,
  onEdit,
  onClose,
  onDownload,
  onUpload,
  editHoverText = staticText.general.edit,
  downloadHoverText = staticText.general.download,
  uploadHoverText = staticText.general.upload,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={cn(styles.detailHeader, classes.detailHeader)}>
      <div className={styles.headerText}>{t(title)}</div>
      <div className={styles.imageContainer}>
        {downloadable && (
          <DownloadButton
            title={downloadHoverText}
            onClick={onDownload}
            className={styles.icon}
            theme="dark"
          />
        )}
        {uploadable && (
          <UploadButton
            title={uploadHoverText}
            onClick={onUpload}
            className={styles.icon}
            theme="dark"
          />
        )}
        {editable && (
          <SvgIcon className={classes.mySvgStyle} onClick={onEdit}>
            <EditLogo
              className={styles.icon}
              title={editHoverText}
              alt={editHoverText}
            />
          </SvgIcon>
        )}
        {closable && (
          <SvgIcon className={classes.mySvgStyle} onClick={onClose}>
            <CloseLogo
              className={styles.icon}
              alt={t(staticText.general.close_details)}
              title={t(staticText.general.close_details)}
            />
          </SvgIcon>
        )}
      </div>
    </Box>
  );
};
PanelHeaderBar.propTypes = {
  editable: PropTypes.bool,
  reply: PropTypes.bool,
  msg: PropTypes.bool,
  downloadable: PropTypes.bool,
  closable: PropTypes.bool,
  onReply: PropTypes.func,
  onMsg: PropTypes.func,
  onEdit: PropTypes.func,
  onDownload: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  editHoverText: PropTypes.string,
  downloadHoverText: PropTypes.string,
  replyText: PropTypes.string,
  msgText: PropTypes.string,
  onUpload: PropTypes.func,
  uploadable: PropTypes.bool,
  uploadHoverText: PropTypes.string,
};
export default PanelHeaderBar;
